export enum B2bApplicantRole {
	Owner = "Owner",
	Operator = "Operator",
	Employee = "Employee",
}

export const b2bCustomerApplicantRoleNameMap: Record<B2bApplicantRole, string> = {
	[B2bApplicantRole.Owner]: "Majitel",
	[B2bApplicantRole.Operator]: "Provozovatel",
	[B2bApplicantRole.Employee]: "Pracovník",
};
